module.exports = __webpack_public_path__ + "static/media/Finance01.d29bef09.png";